import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import SplitText from "gsap/SplitText";

gsap.registerPlugin(ScrollTrigger, SplitText);

const inviewModule = (props) => {
    ScrollTrigger.matchMedia({
        "(min-width: 1024px)": function () {
            document.fonts.ready.then(() => {
                gsap.set(".js-split", { opacity: 1 });

                document.querySelectorAll(".js-split").forEach((el) => {
                    const splitInstance = SplitText.create(el, {
                        type: "words,lines",
                        linesClass: "line",
                        wordsClass: "py-0.5",
                        autoSplit: true,
                        mask: "lines",
                    });

                    const animation = gsap.fromTo(
                        splitInstance.lines,
                        {
                            yPercent: 100,
                            opacity: 0,
                        },
                        {
                            yPercent: -5,
                            opacity: 1,
                            duration: 0.8,
                            stagger: 0.1,
                            ease: "expo.out",
                            paused: true,
                            delay: 0.3,
                        }
                    );

                    ScrollTrigger.create({
                        trigger: el,
                        start: "top 80%",
                        once: true,
                        onEnter: () => {
                            setTimeout(() => {
                                animation.play();
                            }, 100);
                        },
                    });
                });
            });
        }
    });
};

export { inviewModule };
